var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"button",staticClass:"button",class:_vm.classes,domProps:{"textContent":_vm._s(_vm.text)},on:{"click":_vm.handleClick}})}
var staticRenderFns = []

export { render, staticRenderFns }